module.exports = __webpack_public_path__ + "static/media/vail-14.2f9a5582.jpg";